import { ArticleHeadline } from  './ArticleHeadline'

export default ArticleHeadline
